export default __webpack_public_path__ + "static/media/Invoicing-EN.29256ad7.png";